import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3af50bdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "qrcode-generator" };
const _hoisted_2 = { class: "qrcode-generator__wa-icon" };
import QrcodeVue from 'qrcode.vue';
import WhatsappIcon from '@/components/icons/WhatsappIcon.vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QRCodeGenerator',
    props: ['url', 'size', 'clickable'],
    setup(__props) {
        const props = __props;
        const whatsappIconPosition = computed(() => {
            return `margin: ${whatsappIconMargin.value} ${whatsappIconMargin.value} 0 ${whatsappIconMargin.value}`;
        });
        const whatsappIconMargin = computed(() => {
            return (props.size / 2) - (whatsappIconSize.value / 2);
        });
        const whatsappIconSize = computed(() => {
            return props.size / 4;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(WhatsappIcon, {
                        color: "black",
                        fill: "white",
                        size: _unref(whatsappIconSize),
                        style: _normalizeStyle(_unref(whatsappIconPosition))
                    }, null, 8, ["size", "style"])
                ]),
                _createVNode(QrcodeVue, {
                    value: __props.url,
                    size: __props.size,
                    level: "H"
                }, null, 8, ["value", "size"])
            ]));
        };
    }
});
